import { render, staticRenderFns } from "./eudr-signup.vue?vue&type=template&id=f07bc07e&scoped=true"
import script from "./eudr-signup.vue?vue&type=script&lang=js"
export * from "./eudr-signup.vue?vue&type=script&lang=js"
import style0 from "./eudr-signup.vue?vue&type=style&index=0&id=f07bc07e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07bc07e",
  null
  
)

export default component.exports